/* eslint-disable @typescript-eslint/no-empty-function */
import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import dots from "icons/solid/ellipsis.svg";

interface Props {
  onClick?: any;
  loading?: boolean;
}
export default function InactiveListControlsButton({
  onClick = () => {},
  loading = false,
}: Props) {
  return (
    <div>
      <Button variant="unstyled" size="md" onClick={onClick}>
        {loading ? (
          <LoadingSpinner size="sm" />
        ) : (
          <Icon icon={dots} size="sm" className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
}
